import { lastValueFrom } from 'rxjs';

import { computed, inject, Injectable } from '@angular/core';
import { VendorsService } from '@core/services';
import { VendorName } from '@shared/models';
import { injectQuery } from '@tanstack/angular-query-experimental';

@Injectable({
  providedIn: 'root',
})
export class VendorsStore {
  private vendorsService = inject(VendorsService);
  vendorsQuery = injectQuery(() => ({
    queryKey: ['vendors'],
    queryFn: () => lastValueFrom(this.vendorsService.getVendors()),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  }));
  vendors = computed(() => this.vendorsQuery.data() || []);
  isVendorsAvailable = computed(() => this.vendors().some((vendor) => vendor.active));
  isOxxoActive = computed(
    () => !!this.vendors().find((vendor) => vendor.vendor_name === VendorName.DigitalFemsa)?.active
  );
  paypalKey = computed(
    () => this.vendors().find((vendor) => vendor.vendor_name === VendorName.PayPal && vendor.active)?.token
  );
  isConektaActive = computed(
    () => !!this.vendors().find((vendor) => vendor.vendor_name === VendorName.Conekta)?.active
  );
  isOpenPayActive = computed(
    () => !!this.vendors().find((vendor) => vendor.vendor_name === VendorName.OpenPay)?.active
  );
  isPayCodeActive = computed(
    () => !!this.vendors().find((vendor) => vendor.vendor_name === VendorName.PayCode)?.active
  );
}
